import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {

	states_all: ['newly', 'preparing', 'prepared', 'processing', 'received', 'qualitied', 'reworking', 'finished', 'canceled', 'returned'],
	//   passRange: [
	//     { label: '1天', key: 'pass1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
	//     { label: '2天', key: 'pass2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
	//     { label: '3天', key: 'pass3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
	//     { label: '4-7天', key: 'pass4', condition: { passRangeStart: 4, passRangeEnd: 7 } },
	//     { label: '全部', key: 'pas-all', condition: { passRangeStart: 1, passRangeEnd: 100 } }
	//   ],
	//   nearRange: [
	//     { label: '今天', key: 'near-today', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
	//     { label: '明天', key: 'near-tomorrow', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
	//     { label: '后天', key: 'near-datmr', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
	//     { label: '4-7天', key: 'near-4-7', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
	//     { label: '本周', key: 'near-week', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.beginOfThisWeek())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfThisWeek()) + ' 23:59:59' } }
	//   ],
	// 2021-11-10
	create(params) {
		return axios.post('/weddingDressHall/order', params)
	},
	// 2021-11-10
	insertBatch(params) {
		return axios.post('/weddingDressHall/order/insert-batch', params)
	},
	// 2021-11-10
	findBySerialNo(params) {
		return axios.get('/weddingDressHall/order/find-by-serial-no', params)
	},
	//  2021-11-10
	update(id, params) {
		return axios.put('/weddingDressHall/order/' + id, params)
	},
	// 2021-11-10
	delete(id) {
		return axios.delete('/weddingDressHall/order/' + id)
	},
	// 2021-11-10
	cancel(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/cancel', params)
	},
	// 2021-11-10
	return(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/return', params)
	},
	// 2021-11-11
	preparing(id) {
		return axios.put('/weddingDressHall/order/' + id + '/preparing')
	},
	// 2021-11-11
	prepared(id) {
		return axios.put('/weddingDressHall/order/' + id + '/prepared')
	},
	// 2021-11-11 现货交付
	spotDelivery(id) {
		return axios.put('/weddingDressHall/order/' + id + '/spot-delivery')
	},
	// 2021-11-11
	delivery(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/delivery', params)
	},
	// 2021-11-11
	processing(id) {
		return axios.put('/weddingDressHall/order/' + id + '/processing')
	},
	// 2021-11-11
	receive(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/receive', params)
	},
	// 2021-11-11
	quality(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/quality', params)
	},
	// 2021-11-11
	rework(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/rework', params)
	},
	// 2021-11-11
	receiveAndQuality(id, params) {
		return axios.put('/weddingDressHall/order/' + id + '/receive-and-quality', params)
	},
	// 2021-11-10
	findById(id) {
		return axios.get('/weddingDressHall/order/' + id);
	},

}